
webpack.register(
    'components/sponsor/amex-sponsor/amex-sponsor',
    function() {
        return import('components/sponsor/amex-sponsor/amex-sponsor');
    },
    true
);